"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Config_1 = __importDefault(require("utils/Config"));
const defaultProps = {
    imageId: 'image-id',
    dataCy: 'aws-image',
    onErrorImage: Config_1.default.asset.culture.brokenImageCenter
};
const AWSImage = ({ imageId, src, className, onClick, dataCy, key, onMouseDown, alt, onError, onErrorImage, onMouseOver, onMouseOut, style, dataName }) => {
    const errorImage = (e) => {
        const target = e.target;
        onErrorImage && target.setAttribute('src', onErrorImage);
    };
    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick(e);
        }
    };
    return (react_1.default.createElement("img", { crossOrigin: process.env.NODE_ENV != 'development' ? 'anonymous' : undefined, id: imageId || dataCy, src: src, className: className, "data-cy": dataCy, key: key || dataCy, onError: (e) => (onError ? onError(e) : errorImage(e)), onClick: (e) => handleClick(e), onMouseDown: () => onMouseDown && onMouseDown(), onMouseOver: () => onMouseOver && onMouseOver(), onMouseOut: () => onMouseOut && onMouseOut(), alt: alt || key, style: style && style, "data-name": dataName }));
};
AWSImage.defaultProps = defaultProps;
exports.default = AWSImage;
